<script setup>
// T-246 — o painel ao vivo vira o funil da operação.
//
// Os blocos são Abertas, Retidas pelo Bira, Transferidas para humano, Não atribuídas, Em
// atendimento e Transferidas para pendências, NESTA ORDEM, porque é o caminho que o atendimento
// percorre. Lido da esquerda para a direita, o painel conta onde os casos estão parados.
//
// "Finalizadas" não entra, por decisão da reunião: ao vivo é o que está acontecendo agora, e
// finalizada já acabou.
//
// ⚠️ OS BLOCOS NÃO SOMAM O TOTAL, e a tela diz isso. "Abertas" é o universo e os outros são
// recortes que se sobrepõem: a mesma conversa pode estar em atendimento e em pendência. Sem essa
// frase, alguém soma as caixas e conclui que o número está errado.
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';
import FunilAoVivoAPI from 'dashboard/api/fandata/funilAoVivo';
import MetricCard from './overview/MetricCard.vue';

const { t } = useI18n();

const etapas = ref([]);
const carregando = ref(true);

const buscar = async () => {
  try {
    const { data } = await FunilAoVivoAPI.get();
    etapas.value = data.etapas || [];
  } catch (e) {
    etapas.value = [];
  } finally {
    carregando.value = false;
  }
};

const { startRefetching } = useLiveRefresh(buscar);

onMounted(() => {
  buscar();
  startRefetching();
});
</script>

<template>
  <MetricCard
    :header="t('FUNIL_AO_VIVO.HEADER')"
    :is-loading="carregando"
    :loading-message="t('FUNIL_AO_VIVO.CARREGANDO')"
  >
    <div class="flex flex-col w-full gap-3">
      <p class="text-sm text-n-slate-11">{{ t('FUNIL_AO_VIVO.HINT') }}</p>

      <div class="grid w-full grid-cols-2 gap-x-4 gap-y-4 sm:grid-cols-3 lg:grid-cols-6">
        <div v-for="etapa in etapas" :key="etapa.chave" class="min-w-0">
          <h3 class="text-sm break-words text-n-slate-11">
            {{ t(`FUNIL_AO_VIVO.ETAPA.${etapa.chave.toUpperCase()}`) }}
          </h3>
          <p class="mt-1 mb-0 text-3xl tabular-nums text-n-slate-12">
            {{ etapa.total }}
          </p>
          <!-- A quebra Bira × humano só aparece onde ela significa alguma coisa. Etapa que por
               definição é de um lado só mostra a qual lado pertence: imprimir "humano 0" ali se
               leria como ausência, e não como "não se aplica". -->
          <p v-if="etapa.lado_fixo" class="text-xs text-n-slate-10">
            {{ t(`FUNIL_AO_VIVO.LADO.${etapa.lado_fixo.toUpperCase()}`) }}
          </p>
          <p v-else class="text-xs text-n-slate-11">
            {{ t('FUNIL_AO_VIVO.QUEBRA', { bira: etapa.bira, humano: etapa.humano }) }}
          </p>
        </div>
      </div>
    </div>
  </MetricCard>
</template>
